module.exports = __webpack_public_path__ + "static/media/tengxun.a235fb7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/tengxun.mp4
// module id = f7GV
// module chunks = 0